export default __webpack_public_path__ + "static/media/raiffeisen_background_xl1.f5beceba.jpg";